import { APP_VERSION, VERSION_CHECK_PATH, VERSION_RELOAD_SESSION_KEY } from '@/config/appVersion'

const normalizeVersion = (value) => String(value || '').trim()

const buildVersionUrl = () => {
  const baseUrl = process.env.BASE_URL || '/'
  const normalizedBase = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
  const normalizedPath = VERSION_CHECK_PATH.replace(/^\/+/, '')
  return `${normalizedBase}${normalizedPath}?t=${Date.now()}`
}

export const enforceLatestVersion = async () => {
  if (typeof window === 'undefined' || typeof fetch !== 'function') {
    return false
  }

  try {
    const response = await fetch(buildVersionUrl(), {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })

    if (!response.ok) {
      return false
    }

    const payload = await response.json()
    const serverVersion = normalizeVersion(payload?.version)
    const localVersion = normalizeVersion(APP_VERSION)

    if (!serverVersion || !localVersion) {
      return false
    }

    if (serverVersion === localVersion) {
      window.sessionStorage.removeItem(VERSION_RELOAD_SESSION_KEY)
      return false
    }

    if (window.sessionStorage.getItem(VERSION_RELOAD_SESSION_KEY) === serverVersion) {
      return false
    }

    window.sessionStorage.setItem(VERSION_RELOAD_SESSION_KEY, serverVersion)
    window.location.reload()
    return true
  } catch (error) {
    console.warn('[version-check] failed to verify app version', error)
    return false
  }
}
